import ReadMoreComponent from './components/ReadMoreComponent'
import ReadMoreDirective from './directives/ReadMoreDirective.js'

export default {
  install: function (Vue, options) {
    Vue.component('readMore', ReadMoreComponent)
    Vue.directive('readMore', ReadMoreDirective)
  }
}



//////////////////
// WEBPACK FOOTER
// ./~/vue-read-more/index.js
// module id = 771
// module chunks = 1